import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_TERMS_AND_CONDITION} from "../../utils/input-field-list-static-page";
import InputComponent from "../../components/input.component";
import React, {useEffect} from "react";
import {
    setMoreInfoErrorMessage,
    setMoreInfoTermsAndConditionDetail
} from "../../reducers/more-info.reducer";
import {cloneDeep} from "lodash";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import {LoadingSvg} from "../../utils/image";

const TermsAndConditionPage = () => {
    const dispatch = useDispatch()
    const {termsAndConditionDetail, moreInfoErrorMessage} = useSelector(state => state.moreInfoReducer)
    const {fetching: getTermsAndCondition} = useFetch(API.MORE_INFO_GET_TERMS_AND_CONDITION)
    const {fetching: updateTermsAndCondition, isLoading} = useFetch(API.MORE_INFO_UPDATE_TERMS_AND_CONDITION)
    let fieldList = FIELD_LIST_TERMS_AND_CONDITION

    const onChangeInput = (key, value) => {
        dispatch(setMoreInfoTermsAndConditionDetail({[key]: value}))
    }

    useEffect(() => {
        getTermsAndCondition().then(response => {
            dispatch(setMoreInfoTermsAndConditionDetail(response?.data))
        })

        return () => {
            dispatch(setMoreInfoErrorMessage({}))
        }
    }, [])

    const dataChecking = (field, value) => {
        dispatch(setMoreInfoErrorMessage({}))
        const moreInfoDetailCopy = cloneDeep(termsAndConditionDetail)
        let error = {}
        field.forEach((item) => {
            switch (item.key) {
                case 'description':
                    if (!moreInfoDetailCopy[item.key]) {
                        error[item.key] = `${item.label} is required`
                    }
                    break
                default:
                    if (item.required && !value[item.key]?.value) {
                        error[item.key] = `${item.label} is required`
                    } else {
                        moreInfoDetailCopy[item.key] = value[item.key]?.value || null
                    }
            }
        })

        if (Object.keys(error).length === 0) {
            dispatch(setMoreInfoErrorMessage({}))
            return {isValid: true, termsAndCondition: moreInfoDetailCopy}
        } else {
            dispatch(setMoreInfoErrorMessage(error))
            return {isValid: false, termsAndCondition: moreInfoDetailCopy}
        }
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        let formValue = document.getElementById("form").elements
        const {isValid, termsAndCondition} = dataChecking([...fieldList], formValue)
        if (isValid) {
            updateTermsAndCondition(termsAndCondition).then(response => {
                dispatch(setMoreInfoErrorMessage({}))
                dispatch(setToolsModalVisibility({alert: true}))
                dispatch(setToolsAlertType('success'))
                dispatch(setToolsAlertMessage('Terms and Condition Updated'))
                dispatch(setMoreInfoTermsAndConditionDetail(response?.data))
            }).catch(err => {
                dispatch(setMoreInfoErrorMessage(convertErrorMessage(err)))
            })
        }
    }

    return (
        <div className={"col px-10"}>
            <form id={"form"} className={"space-y-4"}>
                {fieldList.map((item, index) => (
                    <InputComponent key={index} item={item} data={termsAndConditionDetail[item.key]}
                                    onChange={onChangeInput} error={moreInfoErrorMessage}/>
                ))}
                <div className={"row font-semibold justify-center py-8"}>
                    <button onClick={(e) => onSubmitHandler(e)}
                            className={"w-60 py-2 bg-battleship-green hover:bg-gradient-to-b from-battleship-green to-monstera text-white rounded-lg"}>
                        {
                            isLoading ? <img src={LoadingSvg} className={"w-5 mx-auto"}/> : 'Save All Changes'
                        }
                    </button>
                </div>
            </form>
        </div>
    )
}

export default TermsAndConditionPage
